import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types';
import renderIf from 'render-if';
import Button from 'components/CustomButton';
import SearchUser from 'components/SearchUser';
// import UserInfo from '../../../Userinfo/index';
import styles from './styles.scss';

// to import local scss fle

class DeleteCoach extends Component {
  static propTypes = {
    userInfo: PropTypes.shape.isRequired,
    deleteCoach: PropTypes.shape.isRequired,
    coachDeleted: PropTypes.bool.isRequired,
    resetValues: PropTypes.func.isRequired,
    catchUserInfo: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      deleteAnotherCoach: false,
    };
  }

  deleteCoach = () => {
    const payload = {
      coach_id: this.props.userInfo.coach_id,
    };
    this.props.deleteCoach(payload);
    this.setState({ deleteAnotherCoach: false });
  };

  deleteAnotherCoach = () => {
    this.props.resetValues('RESET_DELETE_COACH');
    this.props.catchUserInfo('coachInfo', {});
  };

  render() {
    const { userInfo, coachDeleted } = this.props;
    const renderUserNotSelected = renderIf(!coachDeleted);
    const renderUserSelected = renderIf(userInfo.name !== undefined && !coachDeleted);
    const renderSuccessMessage = renderIf(coachDeleted);
    return (
      <div className={cn('col s12', styles.removePadding)}>
        {renderUserNotSelected(<SearchUser {...this.props} userType="COACH" label="SEARCH USER TO DELETE" />)}
        {renderUserSelected(
          <div>
            <Button label="DELETE ABOVE COACH" style={styles.buttonContainer} onClick={this.deleteCoach} />
            <Button label="SELECT ANOTHER COACH" style={styles.buttonContainer} onClick={this.deleteAnotherCoach} />
          </div>,
        )}
        {renderSuccessMessage(
          <span className={styles.successMessage}>
            Coach with email id {userInfo.email} deleted.<br />
            <Button label="DELETE ANOTHER COACH" style={styles.buttonContainer} onClick={this.deleteAnotherCoach} />
          </span>,
        )}
      </div>
    );
  }
}

export default DeleteCoach;



// WEBPACK FOOTER //
// ./src/containers/Admin/components/CoachView/components/DeleteCoach/View.js